import React from 'react'
import cn from "classnames"
import PropTypes from 'prop-types'
import injectStyles from "react-jss"
import theme from "../../styles/theme"

const Caption = ({classes, className, caption}) => (
    <div key="caption" className={cn(classes.caption, className)} dangerouslySetInnerHTML={{__html: caption}}></div>
)

Caption.propTypes = {
    caption: PropTypes.string.isRequired,
}

export default injectStyles({
    caption: {
        ...theme.font.caption,
        margin: "0.5em 0",
        maxWidth: 560,
        "& p": {
            ...theme.font.caption,
            lineHeight: "1rem", // this is smaller then usual
            margin: 0,
            padding: 0,
        }
    },
})(Caption)





// WEBPACK FOOTER //
// ./src/components/Widgets/Caption.js